// extracted by css-extract-rspack-plugin
export default {"dialog":"BoW_BxanPjEKZr9c","closeButton":"z72Br68_8IEaqVMj","imageContainer":"IYMANjIH01cC3FKl","image":"v2aEufTyidAxTsmr"};